import { CustomState } from "@preferredMedical/Store/CustomState";

export function getProductPromotionsByProductId(state: CustomState, id: string | undefined) {
    if (id !== undefined) {
        if (id in state.custom.productPromotions.productPromotions) {
            const promotions = state.custom.productPromotions.productPromotions[id];
            return promotions;
        }
    }
    return [];
}
